import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-second-card',
  templateUrl: './second-card.component.html',
  styleUrls: ['./second-card.component.css']
})
export class SecondCardComponent implements OnInit {

  @Input() title: string;
  @Input() body: string;
  @Input() icon: string;
  @Input() color: string;
  constructor() { }

  ngOnInit(): void {
  }

}
